/* 
** TODO:  replace commonJS imports here with ES module imports
*/
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as cad from 'common/types/cad.constants';
import { cadZone } from './cad-zone';
import { cadDateUtilInstance } from 'common/utils/date-util';
import { AppModule } from './cad/app.module';
import { LicenseManager } from 'ag-grid-enterprise';
import { environment } from 'src/environments/environment';
import * as jquery from 'jquery';
import * as moment from 'moment-timezone';

// vendor.ts
(window as any).xhook.disable();
import './polyfills';
(window as any).xhook.enable();
// TODO:  is hammerjs needed?  If so, should import via ES module instead of commonJS
// https://angular.io/api/platform-browser/HammerModule
// import 'hammerjs/hammer';
(window as any).jquery = jquery;
(window as any).moment = moment;
(window as any)._ = _;
window.onerror = (errorMsg, url, lineNumber, columnNumber, errorObject) => {
  let errMsg;
  // check the errorObject as IE and FF don't pass it through (yet)
  if (errorObject && errorObject !== undefined) {
    errMsg = errorObject.message;
  } else {
    errMsg = errorMsg;
  }
  console.error('Error: ' + errMsg);
};
// end vendor.ts

// plugins.ts
(() => {
  let method;
  let noop = () => {};
  let methods = [
    'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
    'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
    'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
    'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn',
  ];
  let length = methods.length;
  let console = ((window as any).console = window.console || {});
  while (length--) {
    method = methods[length];
    // Only stub undefined methods.
    if (!console[method]) {
      console[method] = noop;
    }
  }
})();

// Specific to IE
let ua = window.navigator.userAgent;
let oldIe = ua.indexOf('MSIE ');
let newIe = ua.indexOf('Trident/');
if ((oldIe > -1) || (newIe > -1)) {
  let d = document.getElementsByTagName('html')[0];
  d.className += ' ie';
}
// end plugins.ts

LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-083542}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Energy_Transfer_LP}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Messenger+}_only_for_{4}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Messenger+}_need_to_be_licensed___{Messenger+}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{3_November_2026}____[v3]_[01]_MTc5MzY2NDAwMDAwMA==355c8f854339af6dcc842e4a260fa700');

interface MomentWritable {
  defaultFormat: string; // by default TypeScript complains when trying to set defaulFormat which it thinks is read-only
}

if (environment.isReleaseBuild) {
  enableProdMode();
  console.warn('Production mode enabled');
  console.log = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.group = () => {};
}

(moment as MomentWritable).defaultFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZZ'; // set default format in moment
(window as any).cad = cad; // make this a globally available module as cad
(window as any).dateUtil = cadDateUtilInstance; // make this a globally available function as dateUtil
cadDateUtilInstance(); // force construction of singleton
cadZone().run(() => {
  platformBrowserDynamic().bootstrapModule(AppModule).then((platformRef) => {
    console.log('Bootstrap done');
  });
});
